import UploadZipStep from "../../../components/UploadZipStep/UploadZipStep";

const Step2 = (props) => {
    return (
        <UploadZipStep
            {...props}
            stepTitle="STEP 2 - Upload Invoice Documents (ZIP)"
            description="Include scanned copies of invoices, viable reports, and proof of delivery in a ZIP file (Max size: 2MB)."
            filePrefix="Invoice"
            uploadPathPrefix="invoices"
        />
    );
};

export default Step2;